/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LastChatMessageResponseDto } from './lastChatMessageResponseDto';
import { GetUserChatSettingsViewDto } from './getUserChatSettingsViewDto';


export interface GetChatStateResponseDto { 
    /**
     * Id чата
     */
    chatId: string;
    /**
     * Название чата
     */
    chatName: string;
    /**
     * Описание чата
     */
    chatDescription: string | null;
    /**
     * Кол-во непрочитанных пользователем сообщений
     */
    unreadMessageCount: number;
    lastChatMessage?: LastChatMessageResponseDto;
    settings?: GetUserChatSettingsViewDto;
    /**
     * Признак, что писать в чат могут только Админы чата
     */
    onlyForAdmins: boolean;
}

